export default __webpack_public_path__ + "media/images/home/slide_gw_2026_sm-253ef653cdc8afda5b0b457dae012116.png";